import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ScaffoldComponent } from './scaffold.component';
import { FormsModule } from '@angular/forms';
import { SharedModule } from '@app/shared/shared.module';
import { OptionsComponent } from './editor/options/options.component';
import { ControlsComponent } from './editor/controls/controls.component';
import { ControlsModalComponent } from './editor/controls/controls-modal/controls-modal.component';
import { ItemModalComponent } from './editor/item-modal/item-modal.component';
import { ItemsComponent } from './editor/items/items.component';
import { EditorComponent } from './editor/editor.component';
import { ViewComponent } from './view/view.component';
import { RenderedComponent } from './view/rendered/rendered.component';
import { CustomrenderedComponent } from '@scaffold/view/rendered/customrendered/customrendered.component';
import { FlexColumnHeightDirective } from './view/rendered/flex-column-height.directive';
import { FilebrowserComponent } from './view/rendered/filebrowser/filebrowser.component';
import { FileFolderComponent } from './view/rendered/filebrowser/file-folder/file-folder.component';
import { FolderStructureComponent } from './view/rendered/filebrowser/folder-structure/folder-structure.component';
import { FileMoveModalComponent } from './view/rendered/filebrowser/file-move-modal/file-move-modal.component';
import { FileDisplayComponent } from './view/rendered/filebrowser/file-display/file-display.component';
import { ViewModalComponent } from './dialogs/view-modal/view-modal.component';
import { AddDataComponent } from './dialogs/add-data/add-data.component';
import { RetentionRuleModalComponent } from '../admin/components/admin-dataretention/retention-rule-modal/retention-rule-modal.component';
import { AddDataInlineComponent } from './view/add-data-inline/add-data-inline.component';
import { DynamicHeightDirective } from './services/dynamic-height.directive';
import { FileModalComponent } from './dialogs/file-modal/file-modal.component';
import { SearchModalComponent } from './editor/controls/search-modal/search-modal.component';
import { DataSearchComponent } from './tools/data-search/data-search.component';
import { PreviewFrameComponent } from './tools/preview-frame/preview-frame.component';
import { HTMLModalComponent } from './dialogs/htmlmodal/htmlmodal.component';
import { ExportModalComponent } from './dialogs/export-modal/export-modal.component';
import { TimePickerComponent } from '@scaffold/view/rendered/components/time-picker/time-picker.component';
import { PhoneNumberComponent } from './view/rendered/components/phone-number/phone-number.component';
import { ListcardComponent } from '@scaffold/view/rendered/components/listcard/listcard.component';
import { ListindexComponent } from '@scaffold/view/rendered/components/listindex/listindex.component';
import { DayRangePickerComponent } from '@scaffold/view/rendered/components/day-range-picker/day-range-picker.component';
import { BlockStylingComponent } from '@scaffold/view/rendered/components/block-styling/block-styling.component';
import { GeneralCardComponent } from '@scaffold/view/rendered/components/general-card/general-card.component';
import { LinkedLabelComponent } from '@scaffold/view/rendered/components/linked-label/linked-label.component';
import { HeadingComponent } from './view/rendered/components/heading/heading.component';
import { LinkComponent } from './view/rendered/components/link/link.component';
import { AnchorComponent } from './view/rendered/components/anchor/anchor.component';
import { ItemLinkComponent } from './view/rendered/components/item-link/item-link.component';
import { FileLinkComponent } from './view/rendered/components/file-link/file-link.component';
import { LabeledTextComponent } from './view/rendered/components/labeled-text/labeled-text.component';
import { PanelComponent } from './view/rendered/components/panel/panel.component';
import { ConditionalComponent } from './view/rendered/components/conditional/conditional.component';
import { RoleConditionalComponent } from './view/rendered/components/role-conditional/role-conditional.component';
import { FeatureConditionalComponent } from './view/rendered/components/feature-conditional/feature-conditional.component';
import { CreateComponent } from './view/rendered/components/create/create.component';
import { DataLinkComponent } from './view/rendered/components/data-link/data-link.component';
import { ListComponent } from './view/rendered/components/list/list.component';
import { AccordionComponent } from './view/rendered/components/accordion/accordion.component';
import { TabsComponent } from './view/rendered/components/tabs/tabs.component';
import { DataLinkLabelComponent } from './view/rendered/components/data-link-label/data-link-label.component';
import { FlexRowComponent } from './view/rendered/components/flex-row/flex-row.component';
import { YoutubeComponent } from './view/rendered/components/youtube/youtube.component';
import { IframeComponent } from './view/rendered/components/iframe/iframe.component';
import { CourseImageComponent } from './view/rendered/components/course-image/course-image.component';
import { ImageComponent } from './view/rendered/components/image/image.component';
import { FileImageComponent } from './view/rendered/components/file-image/file-image.component';
import { ContainerComponent } from './view/rendered/components/container/container.component';
import { WellComponent } from './view/rendered/components/well/well.component';
import { PaddingComponent } from './view/rendered/components/padding/padding.component';
import { CarouselComponent } from './view/rendered/components/carousel/carousel.component';
import { RowComponent } from './view/rendered/components/row/row.component';
import { ScaffoldViewComponent } from './view/rendered/components/scaffold-view/scaffold-view.component';
import { InputComponent } from './view/rendered/components/input/input.component';
import { SwitchComponent } from './view/rendered/components/switch/switch.component';
import { CheckComponent } from './view/rendered/components/check/check.component';
import { RadioComponent } from './view/rendered/components/radio/radio.component';
import { SelectComponent } from './view/rendered/components/select/select.component';
import { SelectListDisplayComponent } from './view/rendered/components/select-list-display/select-list-display.component';
import { ScaffoldEditorComponent } from './view/rendered/components/scaffold-editor/scaffold-editor.component';
import { NavigationComponent } from './view/rendered/components/navigation/navigation.component';
import { ConnectionComponent } from './view/rendered/components/connection/connection.component';
import { FormComponent } from './view/rendered/components/form/form.component';
import { UploadComponent } from './view/rendered/components/upload/upload.component';
import { ScaffoldWizardComponent } from './view/rendered/components/scaffold-wizard/scaffold-wizard.component';
import { TemplateComponent } from './view/rendered/components/template/template.component';
import { ScaffoldIntegrationComponent } from './view/rendered/components/scaffold-integration/scaffold-integration.component';
import { ScaffoldDataComponent } from './view/rendered/components/scaffold-data/scaffold-data.component';
import { ScaffoldDataSearchComponent } from './view/rendered/components/scaffold-data-search/scaffold-data-search.component';
import { ScaffoldMenuComponent } from './view/rendered/components/scaffold-menu/scaffold-menu.component';
import { DataTableComponent } from './view/rendered/components/data-table/data-table.component';
import { DataArrayComponent } from './view/rendered/components/data-array/data-array.component';
import { TemplateDataArrayComponent } from './view/rendered/components/template-data-array/template-data-array.component';
import { ScaffoldTextComponent } from './view/rendered/components/scaffold-text/scaffold-text.component';
import { DataLinkCountComponent } from './view/rendered/components/data-link-count/data-link-count.component';
import { EditableTextComponent } from './view/rendered/components/editable-text/editable-text.component';
import { ButtonSelectMenuComponent } from './view/rendered/components/button-select-menu/button-select-menu.component';
import { ViewIconComponent } from './editor/view-icon/view-icon.component';
import { ContenteditableModelDirective } from './services/contenteditable-model.directive';
import { AddButtonMenuComponent } from './view/rendered/components/list/add-button-menu/add-button-menu.component';
import { ModelInputComponent } from './editor/controls/model-input/model-input.component';
import { BulkInputComponent } from './view/rendered/components/bulk-input/bulk-input.component';
import { DataVisualsComponent } from './view/rendered/components/data-visuals/data-visuals.component';
import { BaseScaffoldComponent } from './view/rendered/components/base-scaffold/base-scaffold.component';
import { VersionControlComponent } from './sidebars/version-control/version-control.component';
import { VersionItemComponent } from './sidebars/version-control/version-item/version-item.component';
import { VersionFormComponent } from './sidebars/version-control/version-form/version-form.component';
import { LtiToolComponent } from './view/rendered/components/lti-tool/lti-tool.component';
import { HtmldocModalComponent } from './dialogs/htmldoc-modal/htmldoc-modal.component';
import { DataImportComponent } from './view/rendered/components/data-import/data-import.component';
import { CommentListComponent } from './view/rendered/components/comment-list/comment-list.component';
import { CommentCardComponent } from '@app/commenting/comment-card/comment-card.component';
import { CommentsBoardComponent } from '@app/commenting/comments-board/comments-board.component';
import { FileManagerComponent } from './view/rendered/components/file-manager/file-manager.component';
import { CommentFilterComponent } from './view/rendered/components/comment-filter/comment-filter.component';
import { ScaffoldFileViewComponent } from './view/rendered/components/scaffold-file-view/scaffold-file-view.component';
import { InViewportModule } from 'ng-in-viewport';
import { OutcomesModule } from './view/rendered/outcomes/outcomes.module';
import { HiddenDefaultComponent } from './view/rendered/components/hidden-default/hidden-default.component';
import { ScaffoldButtonComponent } from './view/rendered/components/scaffold-button/scaffold-button.component';
import { LearningComponent } from './view/rendered/components/learning/learning.component';
import { SettingsPanelComponent } from './view/rendered/components/settings-panel/settings-panel.component';
import { ViewPanelComponent } from './sidebars/view-panel/view-panel.component';
import { VersionSidebarComponent } from './sidebars/version-control/version-sidebar/version-sidebar.component';
import { FileUploadModalComponent } from './view/rendered/filebrowser/file-upload-modal/file-upload-modal.component';
import { UpNextComponent } from '@scaffold/view/rendered/components/up-next/up-next.component';
import { TextLinkLabelComponent } from './view/rendered/components/text-link-label/text-link-label.component';
import { MentionsComponent } from './view/rendered/components/mentions/mentions.component';
import { DateDisplayComponent } from './view/rendered/components/date-display/date-display.component';
import { IconComponent } from './view/rendered/components/icon/icon.component';
import { ViewFrameComponent } from './routes/view-frame/view-frame.component';
import { EditFrameComponent } from './routes/edit-frame/edit-frame.component';
import { CourseSelectComponent } from './routes/course-select/course-select.component';
import { DocumentSelectComponent } from './routes/document-select/document-select.component';
import { DataListComponent } from './routes/data-list/data-list.component';
import { CourseCreateComponent } from './routes/course-create/course-create.component';
import { ArchiveImportComponent } from './routes/archive-import/archive-import.component';
import { LandingPageComponent } from './routes/landing-page/landing-page.component';
import { FrameworkModule } from '../framework/framework.module';
import { GradebookComponent } from './view/rendered/components/gradebook/gradebook.component';
import { PaginatePageSelectComponent } from '@app/framework/paginate-page-select/paginate-page-select.component';
import { JsonDataComponent } from './tools/json-editor/json-editor.component';
import { ScaffoldJsonComponent } from './view/rendered/components/scaffold-json/scaffold-json.component';
import { TableLikeColumnsComponent } from './view/rendered/components/table-like-columns/table-like-columns.component';

import { EmailModule } from './view/rendered/components/email/email.module';
import { RouterModule } from '@angular/router';
import { KeysFilterInputComponent } from './editor/controls/keys-filter-input/keys-filter-input.component';
import { MapValueComponent } from './editor/controls/map-value/map-value.component';
import { KeySelectComponent } from './editor/controls/key-select/key-select.component';
import { AccountSelectComponent } from './routes/account-select/account-select.component';
import { DirectLinkComponent } from './view/rendered/components/direct-link/direct-link.component';
import { VerifyModalComponent } from '../account/profile/verify-modal/verify-modal.component';
import { TranslationKeyComponent } from './editor/controls/translation-key/translation-key.component';
import { TranslateUpdateComponent } from './editor/controls/translation-key/translate-update/translate-update.component';
import { CourseArchiveProgressComponent } from './view/rendered/components/course-archive-progress/course-archive-progress.component';
import { CourseArchiveProgressDonutChartComponent } from './view/rendered/components/course-archive-progress/course-archive-progress-donut-chart/course-archive-progress-donut-chart.component';
import { UserInstanceSelectComponent } from './view/rendered/components/user-instance-select/user-instance-select.component';
import { CourseArchivePauseIntegrationListComponent } from './view/rendered/components/course-archive-progress/course-archive-pause-integration-list/course-archive-pause-integration-list.component';
import { ReactiveFormsModule } from '@angular/forms';
import { RubricComponent } from './view/rendered/components/rubric/rubric.component';
import { GenericModule } from '@generic/generic.module';
import { SnowflakeAccessComponent } from './routes/snowflake-access/snowflake-access.component';
import { IntegrationStatusComponent } from './view/rendered/components/integration-status/integration-status.component';
import { IntegrationSelectComponent } from './dialogs/integration-select/integration-select.component';
import { QuickHelpComponent } from './dialogs/quick-help/quick-help.component';
import { PermissionConditionalComponent } from './view/rendered/components/permission-conditional/permission-conditional.component';
import { TableauComponent } from './view/rendered/components/tableau/tableau.component';
import { AiDetectionRootComponent } from './view/ai-detection-root/ai-detection-root.component';
import { AlertsComponent } from './routes/alerts/alerts.component';
import { PrimengModule } from '@app/shared/primeng.module';
import { FeatureRestrictionSelectComponent } from './view/rendered/components/feature-restriction-select/feature-restriction-select.component';
import { SelectDataxRoleComponent } from './view/rendered/components/select-datax-role/select-datax-role.component';

@NgModule({
  imports: [
    PrimengModule,
    GenericModule,
    CommonModule,
    FormsModule,
    SharedModule,
    RouterModule,
    ReactiveFormsModule,
    // SlideshowModule,
    InViewportModule,
    FrameworkModule,
    EmailModule,
    OutcomesModule,
  ],
  exports: [
    SelectDataxRoleComponent,
    ScaffoldComponent,
    ItemModalComponent,
    ItemsComponent,
    OptionsComponent,
    ControlsComponent,
    ControlsModalComponent,
    EditorComponent,
    ViewComponent,
    RenderedComponent,
    BaseScaffoldComponent,
    PhoneNumberComponent,
    VersionControlComponent,
    CommentCardComponent,
    CommentsBoardComponent,
    OutcomesModule,
    FrameworkModule,
    CourseArchiveProgressComponent,
    CourseArchiveProgressDonutChartComponent,
    PaginatePageSelectComponent,
  ],
  declarations: [
    SelectDataxRoleComponent,
    AiDetectionRootComponent,
    TableauComponent,
    ScaffoldComponent,
    CourseSelectComponent,
    DocumentSelectComponent,
    ViewFrameComponent,
    EditFrameComponent,
    DataListComponent,
    LandingPageComponent,
    ItemModalComponent,
    ItemsComponent,
    OptionsComponent,
    ControlsComponent,
    ControlsModalComponent,
    EditorComponent,
    CourseCreateComponent,
    ArchiveImportComponent,
    ViewComponent,
    RenderedComponent,
    ViewModalComponent,
    AddDataComponent,
    RetentionRuleModalComponent,
    AddDataInlineComponent,
    DynamicHeightDirective,
    FilebrowserComponent,
    FileFolderComponent,
    FolderStructureComponent,
    FileMoveModalComponent,
    FileModalComponent,
    FileDisplayComponent,
    SearchModalComponent,
    DataSearchComponent,
    CustomrenderedComponent,
    PreviewFrameComponent,
    HTMLModalComponent,
    ExportModalComponent,
    TimePickerComponent,
    PhoneNumberComponent,
    ListcardComponent,
    ListindexComponent,
    DayRangePickerComponent,
    BlockStylingComponent,
    GeneralCardComponent,
    LinkedLabelComponent,
    HeadingComponent,
    LinkComponent,
    AnchorComponent,
    ItemLinkComponent,
    FileLinkComponent,
    LabeledTextComponent,
    PanelComponent,
    ConditionalComponent,
    RoleConditionalComponent,
    FeatureConditionalComponent,
    FeatureRestrictionSelectComponent,
    CreateComponent,
    DataLinkComponent,
    ListComponent,
    AccordionComponent,
    TabsComponent,
    DataLinkLabelComponent,
    FlexRowComponent,
    YoutubeComponent,
    IframeComponent,
    CourseImageComponent,
    ImageComponent,
    FileImageComponent,
    ContainerComponent,
    WellComponent,
    PaddingComponent,
    CarouselComponent,
    RowComponent,
    ScaffoldViewComponent,
    InputComponent,
    SwitchComponent,
    CheckComponent,
    RadioComponent,
    SelectComponent,
    ScaffoldEditorComponent,
    NavigationComponent,
    ConnectionComponent,
    FormComponent,
    UploadComponent,
    ScaffoldWizardComponent,
    TemplateComponent,
    ScaffoldIntegrationComponent,
    ScaffoldDataComponent,
    ScaffoldDataSearchComponent,
    ScaffoldMenuComponent,
    DataTableComponent,
    DataArrayComponent,
    ScaffoldTextComponent,
    DataLinkCountComponent,
    EditableTextComponent,
    ButtonSelectMenuComponent,
    FlexColumnHeightDirective,
    ViewIconComponent,
    ContenteditableModelDirective,
    AddButtonMenuComponent,
    TemplateDataArrayComponent,
    SelectListDisplayComponent,
    ModelInputComponent,
    VersionControlComponent,
    VersionItemComponent,
    VersionFormComponent,
    BulkInputComponent,
    DataVisualsComponent,
    BaseScaffoldComponent,
    LtiToolComponent,
    HtmldocModalComponent,
    DataImportComponent,
    CommentListComponent,
    CommentCardComponent,
    FileManagerComponent,
    CommentsBoardComponent,
    CommentFilterComponent,
    ScaffoldFileViewComponent,
    HiddenDefaultComponent,
    ScaffoldButtonComponent,
    LearningComponent,
    SettingsPanelComponent,
    ViewPanelComponent,
    VersionSidebarComponent,
    FileUploadModalComponent,
    UpNextComponent,
    MentionsComponent,
    TextLinkLabelComponent,
    DateDisplayComponent,
    IconComponent,
    GradebookComponent,
    PaginatePageSelectComponent,
    JsonDataComponent,
    ScaffoldJsonComponent,
    TableLikeColumnsComponent,
    KeysFilterInputComponent,
    MapValueComponent,
    KeySelectComponent,
    AccountSelectComponent,
    DirectLinkComponent,
    VerifyModalComponent,
    TranslationKeyComponent,
    TranslateUpdateComponent,
    CourseArchiveProgressComponent,
    CourseArchiveProgressDonutChartComponent,
    UserInstanceSelectComponent,
    CourseArchivePauseIntegrationListComponent,
    RubricComponent,
    SnowflakeAccessComponent,
    IntegrationStatusComponent,
    IntegrationSelectComponent,
    QuickHelpComponent,
    PermissionConditionalComponent,
    AlertsComponent,
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class ScaffoldModule {}
